import React from 'react'
import { Typography, Grid } from '@mui/material'
import { withNamespaces } from 'react-i18next'

export const EmptyTransactionList = withNamespaces()(({ t }) => {
    return (
        <Grid container spacing={0} justifyContent="center">
            <Typography>{`${t('wallet-no-transactions')}`}</Typography>
        </Grid>
    );
})
